import { useTranslation } from 'next-i18next'
import Image from 'next/image'

export type PaymentIconProps = {
  name: string
  scale?: number
  style?: React.CSSProperties
}

export const PAYMENT_ICONS: { [key: string]: string } = {
  amex: '/embedded/icons/payment_icons/amex.svg',
  applepay: '/embedded/icons/payment_icons/applepay.svg',
  bank: '/embedded/icons/payment_icons/bank.svg',
  discover: '/embedded/icons/payment_icons/discover.svg',
  generic_cc: '/embedded/icons/payment_icons/generic_cc.svg',
  gpay: '/embedded/icons/payment_icons/gpay.svg',
  mastercard: '/embedded/icons/payment_icons/mastercard.svg',
  paypal_icon: '/embedded/icons/payment_icons/paypal_icon.svg',
  secure: '/embedded/icons/payment_icons/secure.svg',
  venmo_icon: '/embedded/icons/payment_icons/venmo_icon.svg',
  venmo_mark: '/embedded/icons/payment_icons/venmo_mark.svg',
  visa: '/embedded/icons/payment_icons/visa.svg',
}

export const PaymentIcon = ({ name, style, scale = 1 }: PaymentIconProps) => {
  const { t } = useTranslation()

  return (
    <Image
      alt={t('PaymentIcon.alt', 'Payment Image')}
      src={PAYMENT_ICONS[name]}
      style={{ transform: `scale(${scale})`, ...style }}
      width={30}
      height={20}
    />
  )
}
